module.exports = __webpack_public_path__ + "static/media/aws_logo.6ff6a5ec.png";